module.exports = __webpack_public_path__ + "static/media/Ellipse 1.ede97d68.svg";